import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import _ from 'lodash';

export default function dashboardGroupAuditReducer(state = initialstate.groupAuditComponents, action) {
	switch (action.type) {
		case types.GET_GROUP_AUDIT_COMPONENTS:
			if (action.response) {
				if (!_.isEmpty(action.response)) {
					//We keep previous and new property to avoid the blank page to fix defect 1132733.
					//TODO: adjust the code to have the new properties names of the GA endpoint.
					return action.response?.map((component) => {
						return {
							...component,
							gaComponentID: component.gaComponentId,
							parentComponentID: component.parentComponentId,
							gaComponentEngagementID: component.gaComponentEngagementId,
							gaLinkStatusID: component.gaLinkStatusId,
							gaScopeID: component.gaScopeId,
							gaScopeTypeID: component.gaScopeTypeId,
							gaInstructionStatusID: component.gaInstructionStatusId,
							taskStatusID: component.taskStatusId,
							gaTaskSendStatusID: component.gaTaskSendStatusId,
							duedate: component.dueDate
						};
					});
				} else {
					return action.response;
				}
			}

			return state;
		case types.CLEAR_GROUP_AUDIT_COMPONENTS:
			return [];
		default:
			return state;
	}
}
